// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Grundlegende Stile */

.app__veranstaltungenStartseite {
  display: flex;
  justify-content: center;
  align-items: stretch; /* Diese Zeile hinzugefügt */
  flex-wrap: wrap;
  max-width: 1100px;
  margin: auto;
}

/* Event-Details und Ihr eigenes Event */
.app__veranstaltungenStartseite-Event,
.app__veranstaltungenStartseite-Your-Event-section {
  flex: 1 1 50%;
  display: flex;
  flex-direction: column;
  background-color: #d9d9d9;
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0px 2px 15px rgba(0,0,0,0.1);
  max-width: 500px;
  min-width: 500px;
  margin: 20px;
  transition: transform 0.3s;
}
.app__veranstaltungenStartseite-Your-Event-section:hover,
.app__veranstaltungenStartseite-Event:hover {
  transform: translateY(-4px);
}
.app__veranstaltungenStartseite_Event-Überschrift,
.app__veranstaltungenStartseite_Event-Überschrift-Your-Event-header {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 15px;
  color: #333333;
  border-bottom: 2px solid var(--color-blue);
}

.app__veranstaltungenStartseite_Event-Details div,
.app__veranstaltungenStartseite-Your-Event-text {
  margin-bottom: 5px;
  color: #666666;
  font-size: 1.1rem;
  line-height: 27px;
}

.app__veranstaltungenStartseite-Your-Event-text h2 {
  font-size: 1.4rem;
  margin-bottom: 5px;
}

.app__veranstaltungenStartseite-Book-Event-button {
  background-color: var(--color-blue);
  color: #ffffff;
  padding: 12px 24px;
  margin-left: 0;
  margin-top: 10px;
  border-radius: 25px;
  font-size: 1.1rem;
  cursor: pointer;
  border: none;
  transition: background-color 0.3s ease-in-out;
}

.app__veranstaltungenStartseite-Book-Event-button:hover {
  background-color: var(--color-dark-blue);
}

/* Responsive Design */
@media (max-width: 768px) {
  .app__veranstaltungenStartseite {
    flex-direction: column;
    align-items: center;
    padding: 20px;
  }
  
  .app__veranstaltungenStartseite-Event,
  .app__veranstaltungenStartseite-Your-Event-section {
    flex: 1 1 100%;
  }

  .app__veranstaltungenStartseite_Event-Details div,
  .app__veranstaltungenStartseite-Your-Event-text {
    font-size: 1rem;
  }
}
@media screen and (max-width:450px) {
.app__veranstaltungenStartseite-Event,
.app__veranstaltungenStartseite-Your-Event-section {
  min-width: 0;
  max-width: 320px;
}
.app__veranstaltungenStartseite_Event-Überschrift,
.app__veranstaltungenStartseite_Event-Überschrift-Your-Event-header {
  font-size: 1.5rem;
}
}`, "",{"version":3,"sources":["webpack://./src/container/VeranstaltungenStartseite/veranstaltungenStartseite.css"],"names":[],"mappings":"AAAA,uBAAuB;;AAEvB;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB,EAAE,4BAA4B;EAClD,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA,wCAAwC;AACxC;;EAEE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;AAC5B;AACA;;EAEE,2BAA2B;AAC7B;AACA;;EAEE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;EACf;;EAEA;;IAEE,cAAc;EAChB;;EAEA;;IAEE,eAAe;EACjB;AACF;AACA;AACA;;EAEE,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;AACnB;AACA","sourcesContent":["/* Grundlegende Stile */\r\n\r\n.app__veranstaltungenStartseite {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: stretch; /* Diese Zeile hinzugefügt */\r\n  flex-wrap: wrap;\r\n  max-width: 1100px;\r\n  margin: auto;\r\n}\r\n\r\n/* Event-Details und Ihr eigenes Event */\r\n.app__veranstaltungenStartseite-Event,\r\n.app__veranstaltungenStartseite-Your-Event-section {\r\n  flex: 1 1 50%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: #d9d9d9;\r\n  padding: 30px;\r\n  border-radius: 10px;\r\n  box-shadow: 0px 2px 15px rgba(0,0,0,0.1);\r\n  max-width: 500px;\r\n  min-width: 500px;\r\n  margin: 20px;\r\n  transition: transform 0.3s;\r\n}\r\n.app__veranstaltungenStartseite-Your-Event-section:hover,\r\n.app__veranstaltungenStartseite-Event:hover {\r\n  transform: translateY(-4px);\r\n}\r\n.app__veranstaltungenStartseite_Event-Überschrift,\r\n.app__veranstaltungenStartseite_Event-Überschrift-Your-Event-header {\r\n  font-size: 2rem;\r\n  font-weight: 600;\r\n  margin-bottom: 15px;\r\n  color: #333333;\r\n  border-bottom: 2px solid var(--color-blue);\r\n}\r\n\r\n.app__veranstaltungenStartseite_Event-Details div,\r\n.app__veranstaltungenStartseite-Your-Event-text {\r\n  margin-bottom: 5px;\r\n  color: #666666;\r\n  font-size: 1.1rem;\r\n  line-height: 27px;\r\n}\r\n\r\n.app__veranstaltungenStartseite-Your-Event-text h2 {\r\n  font-size: 1.4rem;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.app__veranstaltungenStartseite-Book-Event-button {\r\n  background-color: var(--color-blue);\r\n  color: #ffffff;\r\n  padding: 12px 24px;\r\n  margin-left: 0;\r\n  margin-top: 10px;\r\n  border-radius: 25px;\r\n  font-size: 1.1rem;\r\n  cursor: pointer;\r\n  border: none;\r\n  transition: background-color 0.3s ease-in-out;\r\n}\r\n\r\n.app__veranstaltungenStartseite-Book-Event-button:hover {\r\n  background-color: var(--color-dark-blue);\r\n}\r\n\r\n/* Responsive Design */\r\n@media (max-width: 768px) {\r\n  .app__veranstaltungenStartseite {\r\n    flex-direction: column;\r\n    align-items: center;\r\n    padding: 20px;\r\n  }\r\n  \r\n  .app__veranstaltungenStartseite-Event,\r\n  .app__veranstaltungenStartseite-Your-Event-section {\r\n    flex: 1 1 100%;\r\n  }\r\n\r\n  .app__veranstaltungenStartseite_Event-Details div,\r\n  .app__veranstaltungenStartseite-Your-Event-text {\r\n    font-size: 1rem;\r\n  }\r\n}\r\n@media screen and (max-width:450px) {\r\n.app__veranstaltungenStartseite-Event,\r\n.app__veranstaltungenStartseite-Your-Event-section {\r\n  min-width: 0;\r\n  max-width: 320px;\r\n}\r\n.app__veranstaltungenStartseite_Event-Überschrift,\r\n.app__veranstaltungenStartseite_Event-Überschrift-Your-Event-header {\r\n  font-size: 1.5rem;\r\n}\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
